import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

import mediaGallery from "../media-gallery/MediaGalleryMain.vue";
import specs from "./specs.vue";
import usp from "../../../content/usp/usp.vue";
import brandInfo from "./brand-info.vue";
import relatedProducts from "./related-products.vue";
import UnderImage from "./under-image.vue";
import { computed, watch, type PropType, ref } from "vue";
import { type ShopProduct } from "./types";
import labels from "../../shared/labels";
import ProductImageOverlays from "../common/product-image-overlays.vue";
import VideoViewer from "../common/video-link/video-viewer.vue";
import { getBreakpointObservable } from "../../../../shared/breakpoint-observable";
import {
    type PaymentMethodKey,
    type PaymentLogoKey,
} from "../../checkout/payment-type/payment-method";
import { registerVueProductCountdown } from "../../../../utilities/countdown";
import { isValidSecondsleft } from "../../../commons/product/auction/countdown";
import NextToDescriptionImage from "./next-to-description-image.vue";

import fallbackImage from "../fallback-image.jpg?file";
import { type MediaItem } from "../media-gallery/types";

export default /*@__PURE__*/_defineComponent({
  __name: 'shop-product',
  props: {
    product: {
        type: Object as PropType<ShopProduct>,
        required: true,
    },
    paymentKeys: Array as PropType<(PaymentLogoKey | PaymentMethodKey)[]>,
},
  setup(__props) {

const breakpointObserver = getBreakpointObservable();

const props = __props;

const currentBreakpoint = computed(() => {
    return breakpointObserver.currentBreakpoint;
});
const largeView = computed(() => {
    return currentBreakpoint.value?.up("lg") ?? false;
});
const showDescriptionInOwnRow = computed(() => {
    return props.product.stock == null && !props.product.isStockProduct;
});
const productHasStayInformation = computed(() => {
    return (
        props.product.experienceInformation != null &&
        props.product.experienceInformation.stayInclusions.length > 0
    );
});

const media = computed(() => {
    if (props.product.media != null && props.product.media.length > 0)
        return props.product.media;
    const res: MediaItem[] = [
        {
            src: fallbackImage,
            alt: "Billede mangler",
            type: "picture",
            size: {
                width: 470,
                height: 353,
            },
            sources: [],
            srcset: "",
            thumbnail: fallbackImage,
        },
    ];
    return res;
});

const initializedCountdown = ref(false);
const initializedDate = ref<Date>();
const initialSeconds = ref<number>();

watch(
    () => props.product.timeTotalSeconds,
    (n) => {
        if (initializedCountdown.value) return;
        if (!isValidSecondsleft(n)) return;
        initializedCountdown.value = true;
        registerVueProductCountdown({
            itemId: props.product.id,
            secondsGetter: () => props.product.timeTotalSeconds,
            secondsSetter: (v) => {
                props.product.timeTotalSeconds = v;
            },
            getInitializedDate: () => initializedDate.value,
            getInitialSeconds: () => initialSeconds.value,
            setInitializedDate: (v) => (initializedDate.value = v),
            setInitialSeconds: (v) => (initialSeconds.value = v),
        });
    },
    {
        immediate: true,
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style['product-page'])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['content-width', _ctx.$style['product-content']])
    }, [
      (!largeView.value)
        ? (_openBlock(), _createElementBlock("h1", {
            key: 0,
            class: _normalizeClass(_ctx.$style['product-title'])
          }, _toDisplayString(__props.product.name), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true),
      _createVNode(mediaGallery, {
        value: media.value,
        "media-gallery-class": _ctx.$style['media-gallery-container'],
        "full-width": !largeView.value,
        vertical: largeView.value
      }, {
        "under-image": _withCtx(() => [
          (__props.product.underImage != null)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(_ctx.$style['desktop-wrapper-under-image'])
              }, [
                _createVNode(UnderImage, {
                  value: __props.product.underImage
                }, null, 8 /* PROPS */, ["value"])
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true)
        ]),
        "after-first-image": _withCtx(() => [
          _createVNode(ProductImageOverlays, { product: __props.product }, null, 8 /* PROPS */, ["product"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["value", "media-gallery-class", "full-width", "vertical"]),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style['specs-container'])
      }, [
        (largeView.value)
          ? (_openBlock(), _createElementBlock("h1", {
              key: 0,
              class: _normalizeClass(_ctx.$style['product-title'])
            }, _toDisplayString(__props.product.name), 3 /* TEXT, CLASS */))
          : _createCommentVNode("v-if", true),
        _createVNode(specs, {
          product: __props.product,
          "payment-keys": __props.paymentKeys
        }, null, 8 /* PROPS */, ["product", "payment-keys"]),
        (!showDescriptionInOwnRow.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              innerHTML: __props.product.description,
              class: _normalizeClass(_ctx.$style['product-description'])
            }, null, 10 /* CLASS, PROPS */, _hoisted_1))
          : _createCommentVNode("v-if", true),
        (__props.product.videoLink != null && !showDescriptionInOwnRow.value)
          ? (_openBlock(), _createBlock(VideoViewer, {
              key: 2,
              class: _normalizeClass([_ctx.$style['video-viewer']]),
              "video-link": __props.product.videoLink
            }, null, 8 /* PROPS */, ["class", "video-link"]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ], 2 /* CLASS */),
    (__props.product.underImage != null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([_ctx.$style['mobile-wrapper-under-image'], 'content-width'])
        }, [
          _createVNode(UnderImage, {
            value: __props.product.underImage
          }, null, 8 /* PROPS */, ["value"])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    (productHasStayInformation.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(['content-width', _ctx.$style['product-info-boxes']])
        }, [
          (__props.product.experienceInformation != null)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(_ctx.$style['product-info-box'])
              }, [
                _createElementVNode("strong", null, _toDisplayString(__props.product.experienceInformation.stayInclusionHeader), 1 /* TEXT */),
                _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                _createElementVNode("ul", {
                  class: _normalizeClass(_ctx.$style['product-info-list'])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.product.experienceInformation
                            .stayInclusions, (item) => {
                    return (_openBlock(), _createElementBlock("li", null, _toDisplayString(item), 1 /* TEXT */))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ], 2 /* CLASS */)
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          (__props.product.redeemInfo != null)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(_ctx.$style['product-info-box'])
              }, [
                _createElementVNode("strong", null, _toDisplayString(_unref(labels).frontendProductpage.redeemInfoHeader), 1 /* TEXT */),
                _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                _createElementVNode("ul", {
                  class: _normalizeClass(_ctx.$style['product-info-list'])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.product.redeemInfo
                            .replace(/\r/g, '')
                            .split(/(^|\n)\s*[\*-\>●]\s*/g)
                            .filter((x) => x.trim().length > 0), (item) => {
                    return (_openBlock(), _createElementBlock("li", null, _toDisplayString(item), 1 /* TEXT */))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ], 2 /* CLASS */)
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass([
                _ctx.$style['product-description-row'],
                __props.product.nextToDescriptionImage != null ? 'content-width' : '',
            ])
    }, [
      (showDescriptionInOwnRow.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            innerHTML: __props.product.description,
            class: _normalizeClass([
                    'content-width',
                    _ctx.$style['product-description'],
                    __props.product.nextToDescriptionImage != null
                        ? _ctx.$style['product-info-box-base']
                        : '',
                    __props.product.nextToDescriptionImage != null
                        ? _ctx.$style['description-next-to-image']
                        : '',
                ])
          }, null, 10 /* CLASS, PROPS */, _hoisted_2))
        : _createCommentVNode("v-if", true),
      (__props.product.nextToDescriptionImage != null)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass([
                    _ctx.$style['product-info-box-base'],
                    _ctx.$style['next-to-desc-image-container'],
                ])
          }, [
            _createVNode(NextToDescriptionImage, {
              value: __props.product.nextToDescriptionImage
            }, null, 8 /* PROPS */, ["value"])
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      (__props.product.videoLink != null && showDescriptionInOwnRow.value)
        ? (_openBlock(), _createBlock(VideoViewer, {
            key: 2,
            class: _normalizeClass(['content-width', _ctx.$style['video-viewer']]),
            "video-link": __props.product.videoLink
          }, null, 8 /* PROPS */, ["class", "video-link"]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    (__props.product.isStockProduct === true)
      ? (_openBlock(), _createBlock(usp, { key: 2 }))
      : _createCommentVNode("v-if", true),
    (__props.product.brandInfo != null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(['content-width', _ctx.$style['brand-info-comp']])
        }, [
          _createVNode(brandInfo, {
            "brand-info": __props.product.brandInfo
          }, null, 8 /* PROPS */, ["brand-info"])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(['content-width', _ctx.$style['related-info']])
    }, [
      _createVNode(relatedProducts, { product: __props.product }, null, 8 /* PROPS */, ["product"])
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}
}

})